class SketchBuilder {
    /**
     * @param {import('./GeneratorContext').default} context 
     * @param {string} loopCode 
     * @returns {string} 
     */
    static build(context, loopCode) {
        const data = context.getBuilderData();
        
        if (context.language === 'python') {
            return `# Auto-generated by Prarambh Compiler
# Target Board: ${context.board ? context.board.name : 'MicroPython Board'}

${data.includes.join('\n')}

${data.globals.join('\n')}

${data.helpers.join('\n\n')}

# Setup
${data.setup.join('\n')}

# Main loop
while True:
${loopCode || '    pass'}
`;
        } else {
            return `// Auto-generated by Prarambh Compiler
// Target Board: ${context.board ? context.board.name : 'Arduino'}

${data.includes.join('\n')}

${data.globals.join('\n')}

${data.helpers.join('\n\n')}

void setup() {
${data.setup.map(line => `    ${line}`).join('\n')}
}

void loop() {
${loopCode}
}
`;
        }
    }
}

export default SketchBuilder;
